import React from 'react';
import { Button, SpinnerIcon } from '@avila-tek/ui/src';

interface LoadingButtonProps {
  className?: string;
  onClick: () => void;
  loading: boolean;
  text: string;
  spinnerClassName?: string;
}

function LoadingButton({
  className,
  onClick,
  loading,
  text,
  spinnerClassName,
}: LoadingButtonProps) {
  return (
    <Button onClick={onClick} className={`flex justify-center ${className}`}>
      {!loading ? (
        text
      ) : (
        <SpinnerIcon className={`w-5 h-5 text-white ${spinnerClassName}`} />
      )}{' '}
    </Button>
  );
}

export default LoadingButton;
